<nb-layout center>
  <nb-layout-column>
    <nb-card-body>
      <nb-auth-block aria-labelledby="title">
        <div class="col-lg-10 offset-lg-3 col-sm-12 offset-sm-0">
          <div style="padding-left: 12% !important; padding-top: 20vh"><img class="logo" src="/assets/images/logo-fixed.svg" alt=""></div>
          <p class="sub-title" style="margin-top: 30px; letter-spacing: 0.9pt;" i18n="@@AdministrationSystem">Управление проектами</p>

          <nb-alert *ngIf="(state.get('serverError') | async) === true" outline="danger" role="alert">
            <p class="alert-title"><strong i18n="@@Error">Ошибка</strong></p>
            <ul class="alert-message-list">
              <li class="alert-message" i18n="@@ServerError">Возникла ошибка. Попробуйте позже</li>
            </ul>
          </nb-alert>

          <nb-alert *ngIf="(state.get('lockedError') | async) === true" outline="danger" role="alert">
            <p class="alert-title"><strong i18n="@@Error">Ошибка</strong></p>
            <ul class="alert-message-list">
              <li class="alert-message" i18n="@@ServerError">Временная блокировка.
                Вы ввели неверные данные 5 раз. Попробуйте позже
              </li>
            </ul>
          </nb-alert>

          <nb-alert *ngIf="(state.get('status') | async) === 403" outline="danger" role="alert">
            <p class="alert-title"><strong i18n="@@Error">Ошибка</strong></p>
            <ul class="alert-message-list">
              <li class="alert-message" i18n="@@LoginPassIncorrect">Неверно указан логин и/или пароль</li>
            </ul>
          </nb-alert>


          <form aria-labelledby="title" [formGroup]="loginForm" (ngSubmit)="onSubmit()" style="text-align: center">

            <div class="form-control-group">
              <input nbInput
                     fullWidth
                     formControlName="login"
                     type="text"
                     name="login"
                     id="input-email"
                     i18n-placeholder="@@UserName"
                     placeholder="имя пользователя"
              >
              <ng-container *ngIf="loginForm.controls.login.errors?.required && loginForm.controls.login.touched" i18n="@@LoginRequired">
                <p class="caption status-danger">
                  Укажите логин
                </p>
              </ng-container>
            </div>

            <div class="form-control-group">
              <input i18n-placeholder="@@Password" nbInput
                     fullWidth
                     formControlName="password"
                     name="password"
                     type="password"
                     id="input-password"
                     placeholder="пароль"
              >
              <ng-container *ngIf="loginForm.controls.password.errors?.required && loginForm.controls.password.touched" i18n="@@PasswordRequired">
                <p class="caption status-danger">
                  Укажите пароль
                </p>
              </ng-container>
            </div>
            <button nbButton
                    [disabled]="!loginForm.valid"
                    status="primary"
                    i18n="@@SignIn"
                    type="submit"
                    style="width: 150px"
            >
              Войти
            </button>
          </form>
        </div>
      </nb-auth-block>
    </nb-card-body>
  </nb-layout-column>
</nb-layout>
